"use client";

import { useState, useEffect } from "react";

export default function AgeGateModal() {
  const [isVerified, setIsVerified] = useState(false);

  // Read cookie
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  };

  // Set cookie with expiration (in days)
  const setCookie = (name, value, days) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  };

  useEffect(() => {
    const verified = getCookie("jt_age_verified");
    if (verified === "true") {
      setIsVerified(true);
    }
  }, []);

  const handleVerify = () => {
    setCookie("jt_age_verified", "true", 30); // expires in 30 days
    setIsVerified(true);
  };

  const handleDeny = () => {
    window.location.href = "https://google.com";
  };

  if (isVerified) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2 style={styles.title}>Age Verification</h2>
        <p style={styles.text}>
          Journey Trails is a journaling platform intended for adults 21 and older.
          Please confirm your age to continue.
        </p>

        <div style={styles.buttons}>
          <button style={styles.buttonPrimary} onClick={handleVerify}>
            I am 21 or older
          </button>
          <button style={styles.buttonSecondary} onClick={handleDeny}>
            I am under 21
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backdropFilter: "blur(12px)",
    background: "rgba(0,0,0,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999
  },
  modal: {
    background: "rgba(255,255,255,0.08)",
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
    padding: "2rem",
    borderRadius: "18px",
    maxWidth: "420px",
    width: "90%",
    textAlign: "center",
    color: "#fff",
    border: "1px solid rgba(255,255,255,0.18)",
    boxShadow: "0 8px 32px rgba(0,0,0,0.4)"
  },
  title: {
    marginBottom: "1rem",
    fontSize: "1.4rem",
    fontWeight: 600
  },
  text: {
    marginBottom: "1.5rem",
    lineHeight: 1.5,
    color: "rgba(255,255,255,0.85)"
  },
  buttons: {
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem"
  },
  buttonPrimary: {
    padding: "0.75rem",
    background: "rgba(255,255,255,0.9)",
    color: "#000",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: 600
  },
  buttonSecondary: {
    padding: "0.75rem",
    background: "rgba(255,255,255,0.15)",
    color: "#fff",
    border: "1px solid rgba(255,255,255,0.25)",
    borderRadius: "10px",
    cursor: "pointer",
    fontSize: "1rem"
  }
};
